export class Signal {
  private _key = 0;
  private listeners = new Set<() => void>();

  get key(): string {
    return String(this._key);
  }

  subscribe(listener: () => void): void {
    this.listeners.add(listener);
  }

  unsubscribe(listener: () => void): void {
    this.listeners.delete(listener);
  }

  emit(): void {
    this._key++;
    Array.from(this.listeners).forEach((listener) => listener());
  }

  notify(signal: Signal): void {
    this.subscribe(() => signal.emit());
  }
}
